import React, { createContext, useContext, ReactNode } from 'react';
import { SidebarPanel } from 'src/layout/main/right-sidebar/useRightSidebar';
import AssistantChatContext from './AssistanChatContext';

interface RightSidebarContextType {
	isSidebarOpen: boolean;
	activePanel: SidebarPanel;
	handleOpenSidebar: (panel: SidebarPanel) => void;
	handlePanelToggle: (panel: SidebarPanel) => void;
	handleCloseSidebar: () => void;
	openSupport: () => void;
}

const RightSidebarContext = createContext<RightSidebarContextType | undefined>(
	undefined,
);

export const useRightSidebarContext = () => {
	const context = useContext(RightSidebarContext);
	if (!context) {
		throw new Error(
			'useRightSidebarContext must be used within a RightSidebarProvider',
		);
	}
	return context;
};

interface RightSidebarProviderProps {
	children: ReactNode;
	value: Omit<RightSidebarContextType, 'openSupport'>;
}

export const RightSidebarProvider: React.FC<RightSidebarProviderProps> = ({
	children,
	value,
}) => {
	const { closeChat } = useContext(AssistantChatContext);

	const openSupport = () => {
		// Close copilot if it's open to prevent simultaneous panels
		closeChat();
		// Open the sidebar in the support panel
		value.handleOpenSidebar('support');
	};

	const contextValue = {
		...value,
		openSupport,
	};

	return (
		<RightSidebarContext.Provider value={contextValue}>
			{children}
		</RightSidebarContext.Provider>
	);
};

export default RightSidebarContext;
